import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IPartnerDeclaration } from '../interfaces';
import { PartnerDeclarationMapper } from '../mappers';

export type IGetPartnerDeclarationsRepoResponse = IRepoResponse<200, { data: IPartnerDeclaration[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetPartnerDeclarationsRepo = IRepo<[any], IGetPartnerDeclarationsRepoResponse>;

export const GetPartnerDeclarationsRepoType = Symbol.for('GetPartnerDeclarationsRepo');

@bind(GetPartnerDeclarationsRepoType)
export class GetPartnerDeclarationsRepo implements IGetPartnerDeclarationsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/declaration/partner_declarations', query) });

      if (result.status === 200) {
        const data: IPartnerDeclaration[] = result.data.data.map((user) => PartnerDeclarationMapper.toDomain(user));

        return {
          status: 200 as 200,
          response: {
            data: data,
            total: result.data.total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
